import BaseDecorator from "./BaseDecorator";
import * as MoneySum from "lib/utils/MoneySum";

export default class OrderTransferDecorator extends BaseDecorator {
  static get transfer_type_options() {
    if (st.authorize.company.id === 100) {
      return [
        ["bank_wire", I18n.humanAttributeName("order_installment", "bank_wire")],
        ["cash", I18n.humanAttributeName("order_installment", "cash")],
        ["terminal", "Terminal"],
      ];
    }
    if (st.authorize.company.payment_terminal) {
      return [["terminal", "Terminal"]];
    }
    return [
      ["bank_wire", I18n.humanAttributeName("order_installment", "bank_wire")],
      ["cash", I18n.humanAttributeName("order_installment", "cash")],
    ];
  }

  get refund() {
    return this.receiver === "customer";
  }

  get includes_customer() {
    return this.receiver === "customer" || this.sender === "customer";
  }

  get includes_agent() {
    return this.receiver === "agent" || this.sender === "agent";
  }

  // The platform's own settlement side - what Tripsomnia paid out or took in on the order.
  // Kept as a group of its own: a supplier <-> Tripsomnia transfer belongs to neither the
  // customer nor the agent group and would otherwise show nowhere on the order.
  get includes_socialtravel() {
    return this.receiver === "socialtravel" || this.sender === "socialtravel";
  }

  get transaction_amount_differs() {
    return (
      !!this.transaction_amount !== !!this.amount ||
      (this.transaction_amount && this.amount && !MoneySum.isEqual([this.amount], [this.transaction_amount]))
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/OrderTransferDecorator.js